import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-gray-200 bg-white mt-auto" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-500">
      <div className="font-display font-bold text-[#000000] uppercase tracking-[0.15em] text-[11px]">
        UnCloned<span className="text-[#000000]">®</span> Media
      </div>
      <div className="flex items-center gap-4">
        <Link to="/terms" data-testid="footer-terms-link" className="hover:text-[#DF1283] transition-colors">Terms &amp; Copyright</Link>
        <span>© 2026 UnCloned® Media. All rights reserved.</span>
      </div>
    </div>
  </footer>
);
